import React from 'react';

import { Button } from '@components/Button';
import { Dialog } from '@components/Dialog';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { formStrings } from '@utils/forms';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    message: (d2dNo: string) => {
      return `
${d2dNo}の案件を作成しました！
今すぐ予約詳細ページへ行きますか？
      `.trim();
    },
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  managementButton: {
    alignSelf: 'center',
    width: 160,
    margin: '0.5rem 0',
  },
  cancelButton: {
    alignSelf: 'center',
    width: 160,
    margin: '0.5rem 0',
    backgroundColor: theme.palette.grey['500'],
    color: theme.palette.primary.contrastText,
  },
  dialogText: {
    ...common.middleText,
    ...common.fontWeight400,
    ...common.textGray800,
    whiteSpace: 'pre',
    textAlign: 'center',
    marginTop: 20,
    marginBottom: 60,
  },
}));

export const GoToDetailsPageDialog: React.FC<GoToDetailsPageDialogProps> = (props) => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { open, d2dNo, onCancel, onYes } = props;

  return (
    <Dialog open={open}>
      <div className={classes.dialogText}>{strings.message(d2dNo)}</div>
      <Button
        color="primary"
        shape="round"
        size="small"
        className={classes.managementButton}
        text={formStrings.yes}
        onClick={onYes}
      />
      <Button
        color="custom"
        shape="round"
        size="small"
        className={classes.cancelButton}
        text={formStrings.cancel}
        onClick={onCancel}
      />
    </Dialog>
  );
};

export interface GoToDetailsPageDialogProps {
  open: boolean;
  d2dNo: string;
  onCancel: () => any;
  onYes: () => any;
}
